import { render, staticRenderFns } from "./order-confirm-payment.vue?vue&type=template&id=8405b336"
import script from "./order-confirm-payment.vue?vue&type=script&lang=js"
export * from "./order-confirm-payment.vue?vue&type=script&lang=js"
import style0 from "./order-confirm-payment.vue?vue&type=style&index=0&id=8405b336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports